<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <!--<select #langSelect class="btn btn-secondary dropdown-toggle modeSelector" (change)="translate.use(langSelect.value)">
                <option *ngFor="let lang of translate.getLangs()" [value]="lang" [selected]="lang === translate.currentLang">{{ lang }}</option>
            </select>-->

            <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                <h1 class="h3 mb-0 text-gray-800">{{ 'ANNOUNCEMENTS.TITLE' | translate }}</h1>
                <a (click)="openModal()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                    <i class="fas fa-plus text-white-50"> <span class="button-text"> {{ 'ANNOUNCEMENTS.BTN_TEXT' | translate }}</span></i>
                </a>
            </div>

            <ng-container *ngIf="loading">
                <div class="loading text-center">
                    <br />
                    <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
                    <br />
                    <p>Loading, please wait...</p>
                </div>
            </ng-container>

            <ng-container *ngIf="!loading">

                <div class="card shadow">

                    <div class="container-fluid">
                        <div style="width: 100%; max-height: 400px; height:400px;">
                            <ag-grid-angular #agGrid
                                                style="width: 100%; height: 100%;"
                                                class="ag-theme-balham"
                                                [enableFilter]="true"
                                                [floatingFilter]="true"
                                                [gridOptions]="gridOptions"
                                                [rowData]="data"
                                                [columnDefs]="dataHeaders"
                                                [enableSorting]="true"
                                                [enableColResize]="true"
                                                (rowClicked)="onRowClicked($event)"
                                                (gridReady)="onGridReady($event)"
                                                [pagination]="true"
                                                [paginationPageSize]="25"
                                                [overlayNoRowsTemplate]="overlayNoRowsTemplate">
                            </ag-grid-angular>
                        </div>

                        <!--<h2>{{ 'HOME.TITLE' | translate }}</h2>-->

                            <!--<div>{{ 'HOME.Intro' | translate:user }}</div>-->

                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>


<!--/*modal*/-->
<div id="announcementModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Announcement</h2>
                <button *ngIf="!creating;" (click)="closeModal()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">

                <div *ngIf="!creating;" class="align-items-center justify-content-between d-sm-flex align-items-center justify-content-between mb-4">
                    <div></div>
                    <a *ngIf="announcementId != 0" (click)="openConfirmationModal()" class="d-none d-sm-inline-block btn btn-sm btn-red shadow-sm">
                        <i class="fas fa-trash text-white-50"> <span class="button-text">Delete</span></i>
                    </a>
                </div>

                <div class="row">
                    <div class="col-md-2 noPadding">
                        <label for="area">Text</label>
                    </div>
                    <div class="col-md-10 noPadding">
                        <textarea id="area"></textarea>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-2 noPadding">
                        <label style="text-align: right;">Expires On:</label>
                    </div>
                    <div class="col-md-6 noPadding">
                        <!-- NEW DATE PICKER -->
                        <input id="inputAnnouncementDatePicker" type="date" [(ngModel)]="expiresOnDate" (change)="onDateSelect(expiresOnDate)" [min]="getTodayDate2()">
                        <!-- NEW DATE PICKER -->
                        <!-- <angular2-date-picker (onDateSelect)="onDateSelect($event)" [(ngModel)]="expiresOnDate" [settings]="settings"></angular2-date-picker> -->
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-2 noPadding">
                        <label></label>
                    </div>
                    <div class="col-md-2 noPadding">
                        <div class="checkbox" style="display: contents;">
                            <input (change)="changeStatus()" id="statusCheckbox" type="checkbox" [checked]="checkboxStatus">
                            <label for="statusCheckbox">Enabled</label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="row">
                    <div class="col-md-12">
                        <button *ngIf="!creating;" (click)="closeModal()" type="button" class="btn btn-secondary">Cancel</button>
                        <button *ngIf="!creating; else creatingElse;" (click)="saveAnnouncement()" type="button" class="btn btn-primary">Save</button>
                        <ng-template #creatingElse>
                            <button disabled class="d-none d-sm-inline-block btn btn-sm btn-other shadow-sm readyBtn">
                                <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="font-size:20px;padding:0;position: relative;top:0px;"></i> Saving
                            </button>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*CONFIRMATION DELETE MODAL*/-->
<div id="confirmationDeleteModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Delete Announcement</h2>
                <button *ngIf="!deleting;" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <p>Are you sure you want to delete this <b>Announcement</b>?</p>
            </div>

            <div class="modal-footer">
                <div class="row">
                    <div class="col-md-12">
                        <button *ngIf="!deleting;" data-dismiss="modal" type="button" class="btn btn-secondary">Cancel</button>
                        <button *ngIf="!deleting; else deletingElse;" (click)="deleteAnnouncement()" type="button" class="btn btn-primary">Ok</button>
                        <ng-template #deletingElse>
                            <button disabled class="d-none d-sm-inline-block btn btn-sm btn-other shadow-sm readyBtn">
                                <i class="fa fa-spinner fa-pulse fa-3x fa-fw" 
                                   style="font-size:20px;padding:0;position: relative;top:0px;"></i> Deleting
                            </button>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>